import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/open-mdx.png'
import _imports_1 from '@/assets/logo-nepen.png'


const _hoisted_1 = { class: "login-bg align-center relative flex !h-screen items-center justify-center" }
const _hoisted_2 = { class: "absolute left-4 top-4" }
const _hoisted_3 = { class: "login-card h-fit w-11/12 rounded-xl p-8 shadow backdrop-blur-md sm:w-10/12 md:w-[420px] md:p-12" }
const _hoisted_4 = { class: "mb-4 mt-8 flex overflow-hidden rounded-lg border border-sky-200" }
const _hoisted_5 = {
  key: 0,
  class: "text-sky-900 dark:text-slate-50"
}
const _hoisted_6 = { class: "mb-2 block font-bold" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_8 = { class: "mt-4 block font-bold" }
const _hoisted_9 = { class: "relative w-full" }
const _hoisted_10 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_11 = { class: "my-4" }
const _hoisted_12 = {
  key: 1,
  class: "text-sky-900 dark:text-slate-50"
}
const _hoisted_13 = { class: "mb-2 block font-bold" }
const _hoisted_14 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_15 = { class: "mt-4 block font-bold" }
const _hoisted_16 = { class: "relative w-full" }
const _hoisted_17 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_18 = { class: "mt-4 flex flex-col items-center justify-center gap-4" }

import ThemeSwitcher from '@/components/ThemeSwitcher .vue'
import RecoverPassword from '@/components/login/RecoverPassword.vue'
import Icons from '@/components/subcomponents/Icons.vue'
import SelectLanguage from '@/components/subcomponents/SelectLanguage.vue'
import {
  resetNoValidClientToast,
  resetUnauthenticatedState,
} from '@/composables/unauthenticatedToast'
import { useDarkMode } from '@/composables/useDarkMode'
import * as loginServices from '@/services/userService'
import { useClientStore } from '@/stores/ClientStore'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useLoginValidator } from '@/validators/loginValidator'
import { useToast } from 'primevue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import { reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const languageStore = useLanguageStore()
const toast = useToast()
const router = useRouter()
const { isDark } = useDarkMode()
const clientStore = useClientStore()

const { createForm, createEmptyErrors, normalizeCredential, validateAdForm, validateLocalForm } =
  useLoginValidator()

const emailForm = reactive(createForm())
const ldapForm = reactive({ username: '', password: '' })
const errors = reactive<{ email: string; password: string; ldapUsername: string }>({
  email: '',
  password: '',
  ldapUsername: '',
})
const isLoading = ref(false)
const showPassword = ref('password')
const passwordIcon = ref('eye-closed')
const errorMessage = ref('')
const activeTab = ref<'email' | 'ldap'>('email')

const switchTab = (tab: 'email' | 'ldap') => {
  activeTab.value = tab
  Object.assign(errors, { email: '', password: '', ldapUsername: '' })
  errorMessage.value = ''
  ldapForm.username = ''
  ldapForm.password = ''
  emailForm.email = ''
  emailForm.password = ''
}

const handlePassword = () => {
  showPassword.value = showPassword.value === 'password' ? 'text' : 'password'
  passwordIcon.value = passwordIcon.value === 'eye-closed' ? 'eye-open' : 'eye-closed'
}

const validateActiveForm = () => {
  if (activeTab.value === 'email') {
    const validation = validateLocalForm(emailForm)
    Object.assign(errors, validation.errors)
    return validation.isValid
  }

  const validation = validateAdForm({ email: ldapForm.username, password: ldapForm.password })
  errors.ldapUsername = validation.errors.email ?? ''
  errors.password = validation.errors.password ?? ''
  return validation.isValid
}

watch(
  () => languageStore.locale,
  () => {
    if (!errors.email && !errors.password && !errors.ldapUsername) {
      return
    }

    validateActiveForm()
  },
)

const login = () => {
  if (!validateActiveForm()) {
    return
  }

  const normalizedEmail = normalizeCredential(emailForm.email)

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .login(normalizedEmail, emailForm.password)
    .then((res) => {
      resetUnauthenticatedState()
      resetNoValidClientToast()
      clientStore.resetState()
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

const loginAd = () => {
  if (!validateActiveForm()) {
    return
  }

  const normalizedUsername = normalizeCredential(ldapForm.username)

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .loginAd(normalizedUsername, ldapForm.password, null)
    .then((res) => {
      resetUnauthenticatedState()
      resetNoValidClientToast()
      clientStore.resetState()
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      if (errorMessage.value === 'UserNotAssociated') {
        router.push({
          name: 'Associate',
          state: { username: normalizedUsername, password: ldapForm.password },
        })
        return
      }

      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ThemeSwitcher, {
        modelValue: _unref(isDark),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDark) ? (isDark).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mb-4 flex items-center justify-center gap-4" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo openmdx",
          class: "h-18 w-auto"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex-1 py-2 text-sm font-semibold transition-colors", 
            activeTab.value === 'email'
              ? 'bg-sky-600 text-white dark:bg-[var(--p-primary-color)] dark:text-[var(--p-surface-ground)]'
              : 'bg-white/50 text-sky-800 hover:bg-sky-50 dark:text-[var(--p-surface-ground)]'
          ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab('email')))
        }, _toDisplayString(_unref(languageStore).t('auth.login.tabEmail')), 3),
        _createElementVNode("button", {
          class: _normalizeClass(["flex-1 py-2 text-sm font-semibold transition-colors", 
            activeTab.value === 'ldap'
              ? 'bg-sky-600 text-white dark:bg-[var(--p-primary-color)] dark:text-[var(--p-surface-ground)]'
              : 'bg-white/50 text-sky-800 hover:bg-sky-50 dark:text-[var(--p-surface-ground)]'
          ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (switchTab('ldap')))
        }, _toDisplayString(_unref(languageStore).t('auth.login.tabLdap')), 3)
      ]),
      (activeTab.value === 'email')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(languageStore).t('auth.login.emailLabel')), 1),
            _createVNode(_unref(InputText), {
              id: "email",
              type: "email",
              maxlength: "128",
              placeholder: _unref(languageStore).t('auth.login.placeholders.email'),
              onKeydown: _withKeys(login, ["enter"]),
              modelValue: emailForm.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailForm.email) = $event)),
              class: _normalizeClass([{ 'p-invalid': errors.email }, "w-full"])
            }, null, 8, ["placeholder", "modelValue", "class"]),
            (errors.email)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(errors.email), 1))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(languageStore).t('auth.login.passwordLabel')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(InputText), {
                id: "password",
                type: showPassword.value,
                maxlength: "128",
                placeholder: _unref(languageStore).t('auth.login.placeholders.password'),
                class: _normalizeClass([{ 'p-invalid': errors.password }, "w-full !pr-11"]),
                modelValue: emailForm.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((emailForm.password) = $event)),
                onKeydown: [
                  _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  _withKeys(login, ["enter"])
                ]
              }, null, 8, ["type", "placeholder", "class", "modelValue"]),
              _createVNode(Icons, {
                icon: passwordIcon.value,
                size: 24,
                class: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer select-none text-gray-400",
                onClick: handlePassword
              }, null, 8, ["icon"])
            ]),
            (errors.password)
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(errors.password), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(RecoverPassword)
            ]),
            _createVNode(_unref(Button), {
              label: _unref(languageStore).t('auth.login.submitButton'),
              class: "w-full",
              onClick: login,
              loading: isLoading.value
            }, null, 8, ["label", "loading"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'ldap')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(languageStore).t('auth.login.usernameLdapLabel')), 1),
            _createVNode(_unref(InputText), {
              id: "ldapUsername",
              type: "text",
              maxlength: "128",
              placeholder: _unref(languageStore).t('auth.login.usernameLdapPlaceholder'),
              onKeydown: _withKeys(loginAd, ["enter"]),
              modelValue: ldapForm.username,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ldapForm.username) = $event)),
              class: _normalizeClass([{ 'p-invalid': errors.ldapUsername }, "w-full"])
            }, null, 8, ["placeholder", "modelValue", "class"]),
            (errors.ldapUsername)
              ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(errors.ldapUsername), 1))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(languageStore).t('auth.login.passwordLabel')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(InputText), {
                id: "ldapPassword",
                type: showPassword.value,
                maxlength: "128",
                placeholder: _unref(languageStore).t('auth.login.placeholders.password'),
                class: _normalizeClass([{ 'p-invalid': errors.password }, "w-full !pr-11"]),
                modelValue: ldapForm.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ldapForm.password) = $event)),
                onKeydown: [
                  _withKeys(loginAd, ["enter"]),
                  _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                ]
              }, null, 8, ["type", "placeholder", "class", "modelValue"]),
              _createVNode(Icons, {
                icon: passwordIcon.value,
                size: 24,
                class: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer select-none text-gray-400",
                onClick: handlePassword
              }, null, 8, ["icon"])
            ]),
            (errors.password)
              ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(errors.password), 1))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "my-4" }, null, -1)),
            _createVNode(_unref(Button), {
              label: _unref(languageStore).t('auth.login.submitButtonAd'),
              class: "w-full",
              onClick: loginAd,
              loading: isLoading.value
            }, null, 8, ["label", "loading"])
          ]))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_unref(Tag), {
            key: 2,
            severity: "danger",
            value: errorMessage.value,
            class: "mt-4 w-full"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _cache[10] || (_cache[10] = _createElementVNode("img", {
          src: _imports_1,
          alt: "logo nepen",
          class: "h-8 w-auto"
        }, null, -1)),
        _createVNode(SelectLanguage, { class: "mx-2" })
      ])
    ])
  ]))
}
}

})